import React from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import useGoogleCalendarSync from '../../hooks/useGoogleCalendarSync';

const AppLayout = () => {
  // Mount sync hook at app level for background auto-sync on data changes
  useGoogleCalendarSync();

  return (
    <div className="min-h-screen bg-surface-50">
      <Helmet>
        <title>coparent</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {/* Desktop sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="lg:pl-72">
        <main className="p-5 lg:p-10 pb-28 lg:pb-10 max-w-6xl">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom nav */}
      <MobileNav />
    </div>
  );
};

export default AppLayout;
